export interface WidgetNavItem {
	widgetCode: string;
	display: string;
	programCode: string;
	path: string;
	suppressFacilityDropdown?: boolean;
}

/** Hard-coded default for client portal until widget_organization_link nav is wired up. */
export const DEFAULT_CLIENT_PORTAL_WIDGET: WidgetNavItem = {
	widgetCode: "MY_TASKS",
	display: "My Tasks",
	programCode: "",
	path: "/MY_TASKS",
	suppressFacilityDropdown: true,
};
